import { useLocation } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import users from 'modules/core/store/collections/users'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import NewLeave from 'modules/timeoff/components/NewLeave'
import { useOnClose } from 'modules/timeoff/hooks/useOnClose'

const NewLeavePage = () => {
  const location = useLocation()
  const leaveTypeId = new URLSearchParams(location.search).get('leave_type_id')
  const employee = users.current.employee
  const handleClose = useOnClose()

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <NewLeave
      currentEmployee={employee}
      leaveTypeId={leaveTypeId}
      onClose={handleClose}
      contractVersions={contractVersions}
      loading={loading}
    />
  )
}

export default NewLeavePage
